import { render, staticRenderFns } from "./ActivityPage.vue?vue&type=template&id=761b22e6&scoped=true"
import script from "./ActivityPage.vue?vue&type=script&lang=js"
export * from "./ActivityPage.vue?vue&type=script&lang=js"
import style0 from "./ActivityPage.vue?vue&type=style&index=0&id=761b22e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761b22e6",
  null
  
)

export default component.exports